module.exports.pathBackend = 'api/Controllers/'
module.exports.pathBackendView = 'api/Views/'